import axios from "axios";
import jwt_decode from "jwt-decode";
import { logOut } from "../../common/utils";
export default class ImportaSanzioniService{
 
 uploadFile(file, onSuccess, onError){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    let formData = new FormData();
    formData.append("file", file);
    axios
      .post(host + "/api/v1/sanzione/caricamentoMassivo", formData, configHeaders)
      .then(
        function (result) {
            if(result.status === 401){
            logOut();
            } else if(result.status === 200) {
                onSuccess(result.data);
            } else if(result.status === 415) {
                onError("File non supportato")
            } else {
                onError()
            }
        },
        function (error) {
         if(error.response.status === 401){
           logOut();
         }
          console.log(
            "errore " + error
          );
          onError();
        }
      );
  }
 
 
 }